/**
 * created by wang lei
  部门媒体 联动 页面
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../../../base/BaseComponent";
import DeptSelect from "../../../../../publishStatistics/component/DeptSelect";
import MediaSelect from "../../../../../publishStatistics/component/MediaSelect";
import {getInfoFromLocalStorage} from "../../../../../../../actions";

export default class Sta_selectLinkage extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            deptList:[],
            mediaList:[],
            deptIds:[]
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDeptIds()
        this.getDept()
    }

    // 获取默认参数
    getDeptIds = () => {
        let {config,onChange,labelCode} =this.props
        if(config?.defaultValue){
            this.state.deptIds = [getInfoFromLocalStorage("currentUser").defaultInfo.dept.id]
            onChange({labelCode:labelCode[0],val:this.state.deptIds.toString()},()=>{
                onChange({fun: "onSearch"})
            })
            onChange({labelCode:labelCode[1],val:''})
            this.getMedia(this.state.deptIds)
        }
    }

    render() {
        const {
            value,
            onChange,
            config = {},
            labelCode,
            size,
            disabled,
            id,
            placeholder,
        } = this.props
        const {style={},configMedia,maxTagCount} = config;
        let {deptList,deptIds} =this.state
        let valueTemp = "";
        if (Array.isArray(deptList)&&deptList.length) {
            valueTemp = value && value.length > 1 ? value[0] ? value[0].split(",") : "" : value;
        }
        return (
            <div style={{display:'flex'}}>
                <DeptSelect deptList={deptList}
                            placeholder={placeholder}
                            style={style}
                            size={size}
                            disabled={disabled}
                            id={id}
                            value={valueTemp}
                            checkDept={(value) => {
                                this.getMedia(value)
                                onChange({labelCode:labelCode[0], val: value.toString()})
                            }}
                            maxTagCount={maxTagCount}
                />
                <MediaSelect ref={ref => this.mediaSelect = ref}
                             // mediaList={this.state.mediaList}
                             style={configMedia?.style}
                             value={value && value[1] ? value[1].split(",") : ''}
                             placeholder={configMedia?.placeholder}
                             size={configMedia?.size}
                             disabled={configMedia?.disabled}
                             id={configMedia?.id}
                             maxTagCount={configMedia?.maxTagCount}
                             checkMedia={(value)=>{
                                 onChange({labelCode:labelCode[1], val: value.toString()})
                             }}
                             statisticsLinkTable={true}
                />
            </div>
        )
    }
    //获取全部所属单位
    getDept = () => {
        this.request({
            url: "/cm-sites-storage-statistics/middle/getAll",
            method: 'get',
            // contentType: 'json',
            body: {},
            callBack: (res) => {
                let deptList = [];
                if (res) {
                    deptList = res
                }
                this.setState({deptList})
            }
        })
    };

    /**
     * 根据单位获取媒体
     * @param{array} deptIds  当前人部门
     * */
    getMedia = (deptIds) => {
        this.request({
            url: "/cm-sites-pms/media/getMediaByDeptIds",
            method: 'post',
            contentType: 'json',
            body: deptIds,
            callBack: (res) => {
                let mediaList = [];
                if (res) {
                    mediaList = res
                }
                if(typeof this.mediaSelect?.getMediaList === "function") {
                    this.mediaSelect.getMediaList(mediaList)
                }
                // this.state.mediaList=mediaList
            }
        })
    };
}